import { AlertTriangle, Clock } from 'lucide-react';
import { getDeadline, getDeadlineBadge } from '../lib/posts';
import type { ChPost } from '../types';

/** "Atrasado 2 dias" / "Prazo hoje" when the deadline needs attention. */
export function DeadlineBadge({ post }: { post: Pick<ChPost, 'due_date' | 'scheduled_date' | 'status'> }) {
  const badge = getDeadlineBadge(getDeadline(post));
  if (!badge) return null;
  const late = badge.tone === 'late';
  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-bold ${
        late ? 'bg-red-100 text-red-700' : 'bg-amber-100 text-amber-800'
      }`}
    >
      {late ? <AlertTriangle className="w-3 h-3" /> : <Clock className="w-3 h-3" />}
      {badge.label}
    </span>
  );
}
